import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const UpdateSummary = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.UpdateSummary,
        method: RequestType.POST,
        data,
    });

const GetSummaryList = (data: any) =>
    request({
        url: ApiURL.Command.GetSummaryList,
        method: RequestType.POST,
        data,
    });

const PrintSummary = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.PrintSummary,
        method: RequestType.POST,
        data,
    });

const AxaptaTransferSummary = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.AxaptaTransferSummary,
        method: RequestType.POST,
        data,
    });

const SummaryCommand = {
    UpdateSummary,
    GetSummaryList,
    PrintSummary,
    AxaptaTransferSummary,
};

export default SummaryCommand;
